import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Card, createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import MenuTable from "./MenuTable";

{
  /*https://react-table.tanstack.com/docs/examples/material-ui-components*/
}

const defaultMaterialTheme = createTheme(
  {
    palette: {
      primary: {
        main: "#008752"
      }
    },
    backdrop: {
      zIndex: 9999999,
      color: "#000"
    }
  }
);

function Menus(props) {
  console.log("Test");
  const navigate = useNavigate();

  const dispatch = useDispatch();

  return (
    <Grid
      className="mt-2"
      container
      spacing={2}
      alignItems="top"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={12} md={10}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={defaultMaterialTheme}>
            <Card>
              <article className="article">
                <div className="container-fluid no-breadcrumb chapter FormIntegration">
                  <h2 className="article-title">Menus</h2>

                  <MenuTable />

                  <div>
                    <Button
                      className="mt-4"
                      variant="contained"
                      onClick={() => {
                        navigate("/app/menuitem");
                      }}
                    >
                      Create New Menu
                    </Button>
                  </div>
                </div>
              </article>
            </Card>
            <Card className="mt-4 d-none">
              <article className="article">
                <div className="container-fluid no-breadcrumb chapter FormIntegration">
                  <div>
                    <h2 className="article-title mb-4">Todo's</h2>
                    <ul>
                      <li>
                        <s>Add search / filter</s>
                      </li>
                      <li>
                        <s>make table longer / more dynamic</s>
                      </li>
                    </ul>
                  </div>
                </div>
              </article>
            </Card>
          </ThemeProvider>
        </StyledEngineProvider>
      </Grid>
    </Grid>
  );
}

export default Menus;
